import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealerProfile } from '@app/domain/model/dealer-profile';

@Component({
  templateUrl: './dealer-query-reports.component.html',
  styleUrls: ['./dealer-query-reports.component.scss']
})
export class DealerQueryReportsComponent implements OnInit {

  profile: DealerProfile;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.data.subscribe(({ profile }) => {
      this.profile = profile;
    });
  }

}
